module.exports = __webpack_public_path__ + "img/march-cover-1.b6d88231.jpeg";